import {
	MantineProvider as BaseMantineProvider,
	CloseIcon,
	Modal,
	Overlay,
	createTheme,
} from '@mantine/core';
import { PropsWithChildren } from 'react';

/* https://mantine.dev/styles/unstyled/
 * Not importing this makes the entire library a headless component library */
import '@mantine/core/styles.css';

import styles from './Mantine.module.css';

const theme = createTheme({
	/** Put your mantine theme override here */
	components: {
		Modal: Modal.extend({
			defaultProps: {
				radius: 10,
				closeButtonProps: {
					icon: <CloseIcon />,
					size: 'lg',
				},
			},
			classNames: {
				header: styles['Modal-header'],
				close: styles['Modal-close'],
			},
		}),
		Overlay: Overlay.extend({
			defaultProps: {
				backgroundOpacity: 0.5,
				color: '#D8E0E8',
				blur: '1px',
			},
		}),
	},
});

export const MantineProvider = ({ children }: PropsWithChildren) => {
	return <BaseMantineProvider theme={theme}>{children}</BaseMantineProvider>;
};
